<template>
	<div class="home-page">
		<div class="main-content">
			<!-- Banner Area -->
			<div class="banner" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
				<div class="banner-track" :style="bannerTrackStyle">
					<div class="banner-slide" v-for="(item, index) in banners" :key="item.id || index"
						:style="{ backgroundImage: item.imgUrl ? `url(${item.imgUrl})` : '' }"
						@click="handleBannerClick(item)">
					</div>
				</div>
				<div class="banner-dots">
					<span v-for="(item, index) in banners" :key="`dot-${item.id || index}`" class="dot"
						:class="{ active: index === currentBannerIndex }" @click="goToBanner(index)"></span>
				</div>
			</div>

			<!-- Categories -->
			<div class="section-container">
				<div class="categories-grid">
					<div class="category-card" v-for="(item, index) in categories.slice(0, 3)" :key="item.id || index"
						@click="goToCourse(item)">
						<div class="card-info">
							<h3>{{ item.name }}</h3>
							<p>{{ item.remark || '连接商业、文化与个体的桥梁。' }}</p>
							<a href="javascript:void(0)" class="learn-more" @click.stop="goToCourse(item)">去学习 ></a>
						</div>
						<div class="card-icon"><img :src="item.icon" alt="" style="border-radius: 100%;" />️</div>
					</div>
					<div class="category-card" @click="goToCourse()">
						<div class="card-info">
							<h3>更多分类</h3>
							<p>发现更多分类，探索更广世界。</p>
							<a href="javascript:void(0)" class="learn-more" @click.stop="goToCourse()">去学习 ></a>
						</div>
						<div class="card-icon">
							<img src="../assets/icon/moreCategories.png" alt="" style="border-radius: 100%;" />
						</div>
					</div>
				</div>

				<!-- Product Groups -->
				<div class="course-section" v-for="(group, index) in productGroups" :key="group.id || index"
					style="padding-bottom: 50px;">
					<div class="section-header">
						<h3>{{ group.name }} 🔥</h3>
						<a href="javascript:void(0)" class="view-more" @click.stop="goToMore(group)">更多 ></a>
					</div>
					<div class="course-grid">
						<div class="course-card" v-for="(course, cIndex) in group.courseList" :key="course.id || cIndex"
							@click="goToDetail(course)">
							<div class="course-cover"
								:style="{ backgroundImage: course.coverImg ? `url(${course.coverImg})` : '' }">
								<span class="badge">{{ getBadgeText(course.viewType) }}</span>
							</div>
							<div class="course-info">
								<h4>{{ course.title }}</h4>
								<p>{{ course.sales || 0 }}人购买</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'

	export default {
		name: 'HelloWorld',
		data() {
			return {
				banners: [],
				currentBannerIndex: 0,
				autoPlayTimer: null,
				productGroups: [],
				categories: []
			}
		},
		computed: {
			bannerTrackStyle() {
				return {
					transform: `translateX(-${this.currentBannerIndex * 100}%)`
				}
			}
		},
		mounted() {
			this.fetchBanners()
			this.fetchProductGroups()
			this.fetchCategories()
			this.startAutoPlay()
		},
		beforeUnmount() {
			this.stopAutoPlay()
		},
		methods: {
			goToMore(group) {
				if (group) {
					this.$router.push({
						path: '/course-more',
						query: {
							productGroupId: group.productGroupId,
							title: group.name || ''
						}
					})
				}
			},
			goToDetail(course) {
				if (course && (course.id || course.courseId)) {
					this.$router.push({
						name: 'CourseDetail',
						params: {
							id: course.id || course.courseId
						}
					})
				}
			},
			goToCourse(item) {
				if (item && (item.categoryId || item.id)) {
					this.$router.push({
						path: '/course',
						query: {
							categoryId: item.categoryId || item.id
						}
					})
				} else {
					this.$router.push({
						path: '/course'
					})
				}
			},
			async fetchCategories() {
				try {
					const data = await request({
						url: '/public/categories',
						method: 'get'
					})
					if (data) {
						this.categories = data
					}
				} catch (error) {
					console.error('获取分类失败:', error)
				}
			},
			getBadgeClass(viewType) {
				if (viewType === 1) return 'free'
				if (viewType === 2) return 'vip'
				return 'paid'
			},
			getBadgeText(viewType) {
				if (viewType === 1) return '免费'
				if (viewType === 2) return 'VIP'
				return '付费'
			},
			async fetchProductGroups() {
				try {
					const data = await request({
						url: '/public/productGroups',
						method: 'get'
					})
					if (data && data.length > 0) {
						this.productGroups = data
					}
				} catch (error) {
					console.error('获取课程分组失败:', error)
				}
			},
			async fetchBanners() {
				try {
					const data = await request({
						url: '/public/banners',
						method: 'get'
					})
					if (data.length > 0) {
						this.banners = data
						this.currentBannerIndex = 0
						this.startAutoPlay()
					}
				} catch (error) {
					console.error('获取轮播图失败:', error)
				}
			},
			handleBannerClick(item) {
				if (!item) return
				// jumpType: 1是课程id
				if (item.jumpType === 1) {
					const id = item.jumpUrl || item.targetId || item.courseId || item.id
					if (id) {
						this.$router.push({
							name: 'CourseDetail',
							params: {
								id: id
							}
						})
					}
				}
				// jumpType: 2是web链接
				else if (item.jumpType === 2) {
					const url = item.jumpUrl || item.link || item.url
					if (url) {
						window.open(url, '_blank')
					}
				}
			},
			normalizeBanner(item = {}) {
				return {
					id: item.id || item.bannerId || item.uuid || '',
					tag: item.tag || item.label || item.typeName || '精选课程',
					subtitle: item.subtitle || item.subTitle || item.secondaryTitle || '',
					title: item.title || item.mainTitle || item.name || '',
					description: item.description || item.desc || item.intro || '',
					buttonText: item.buttonText || item.btnText || '开始学习 >',
					image: item.image || item.imageUrl || item.cover || item.pic || ''
				}
			},
			nextBanner() {
				if (!this.banners.length) return
				this.currentBannerIndex = (this.currentBannerIndex + 1) % this.banners.length
			},
			prevBanner() {
				if (!this.banners.length) return
				this.currentBannerIndex =
					(this.currentBannerIndex - 1 + this.banners.length) % this.banners.length
			},
			goToBanner(index) {
				this.currentBannerIndex = index
			},
			startAutoPlay() {
				this.stopAutoPlay()
				if (this.banners.length <= 1) return
				this.autoPlayTimer = setInterval(() => {
					this.nextBanner()
				}, 3000)
			},
			stopAutoPlay() {
				if (this.autoPlayTimer) {
					clearInterval(this.autoPlayTimer)
					this.autoPlayTimer = null
				}
			}
		}
	}
</script>

<style scoped>
	.home-page {
		min-height: 100vh;
		background-color: #111;
		/* Dark background */
		color: #fff;
	}

	.main-content {
		width: 100%;
	}

	/* Banner */
	.banner {
		background: linear-gradient(to right, #1a0b33, #0d0d26);
		height: 400px;
		position: relative;
		overflow: hidden;
	}

	.banner-track {
		height: 100%;
		display: flex;
		transition: transform 0.5s ease;
	}

	.banner-slide {
		flex: 0 0 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
		position: relative;
		cursor: pointer;
	}

	.banner-arrow {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 36px;
		height: 36px;
		border: none;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		color: #fff;
		font-size: 26px;
		line-height: 1;
		cursor: pointer;
		z-index: 2;
	}

	.banner-arrow.left {
		left: 24px;
	}

	.banner-arrow.right {
		right: 24px;
	}

	.banner-arrow:hover {
		background: rgba(255, 255, 255, 0.35);
	}

	.banner-dots {
		position: absolute;
		left: 50%;
		bottom: 20px;
		transform: translateX(-50%);
		display: flex;
		gap: 8px;
		z-index: 2;
	}

	.dot {
		width: 30px;
		height: 4px;
		border-radius: 2px;
		background: rgba(255, 255, 255, 0.4);
		cursor: pointer;
		transition: all 0.3s;
	}

	.dot.active {
		background: #ffffff;
	}

	/* Section Container */
	.section-container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 40px 20px;
	}

	/* Categories */
	.categories-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;
		margin-bottom: 50px;
	}

	.category-card {
		background-color: #1e1e1e;
		padding: 20px;
		border-radius: 8px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		transition: transform 0.3s;
	}

	.category-card:hover {
		transform: translateY(-5px);
	}

	.card-info h3 {
		margin: 0 0 10px 0;
		font-size: 18px;
	}

	.card-info p {
		font-size: 12px;
		color: #888;
		margin-bottom: 20px;
	}

	.learn-more {
		color: #ff9900;
		text-decoration: none;
		font-size: 12px;
		border: 1px solid #ff9900;
		padding: 2px 8px;
		border-radius: 4px;
	}

	.card-icon img {
		width: 50px;
		height: 50px;
	}

	/* Course Section */
	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.view-more {
		color: #888;
		text-decoration: none;
		font-size: 14px;
	}

	.course-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;

	}

	.course-card {
		background-color: transparent;
	}

	.course-cover {
		height: 160px;
		background-color: #333;
		border-radius: 8px;
		margin-bottom: 10px;
		position: relative;
		overflow: hidden;
		background-size: cover;
		background-position: center;
	}

	.badge {
		position: absolute;
		top: 0;
		right: 0;
		padding: 2px 8px;
		font-size: 12px;
		font-weight: bold;
		border-radius: 0px 6px 0px 6px;
		background: linear-gradient(90deg, #FFC972 0%, #FFA73B 100%);
		color: #522606;
	}





	.course-info h4 {
		margin: 0 0 5px 0;
		font-size: 16px;
	}

	.course-info p {
		margin: 0;
		font-size: 12px;
		color: #888;
	}
</style>